<template>
  <el-card>

    <el-form ref="form" :model="listForm" label-width="80px" inline>
      <el-form-item>
        <el-input @clear="init" v-model="listForm.name" placeholder="请输入视频名称" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="resetPagination" type="primary">查询</el-button>
      </el-form-item>
      <el-form-item class="fr">
        <el-button @click="handleOpera" type="primary">添加视频</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list">
      <el-table-column prop="id" label="视频ID">
      </el-table-column>
      <el-table-column prop="name" label="视频名称">
      </el-table-column>
      <el-table-column prop="createdAt" label="添加时间">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-link @click="handlePlayer(scope)" type="primary">播放预览</el-link>
          <el-link @click="handleOpera(scope)" type="primary">编辑</el-link>
          <el-link @click="onDelete(scope)" type="danger">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-if="meta" :total="meta.total" :pagination="meta.pagination" :changed="changed" />
    <el-dialog :title="submitForm.id ?  '编辑视频':'新增视频'" :visible.sync="dialogVisible" width="500px">
      <el-form ref="form" :model="submitForm" :rules="rules" label-width="auto">
        <el-form-item label="视频名称:" prop="name">
          <el-input v-model.trim="submitForm.name" placeholder="请输入视频名称" maxlength="30"></el-input>
        </el-form-item>
        <el-form-item label="上传视频:" prop="url">
          <uploader-oss :file-list="submitForm.url" target="upload" :params="{folder:'music-score',type:'video'}" @success="success" @remove="remove" showFileList :limit="1" accept="video/*">
            <el-button size="small" type="primary">点击上传</el-button>
          </uploader-oss>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <player ref="player"></player>
  </el-card>
</template>

<script>
import {
  createPlay,
  deleteAccompaniment,
  deletePlay,
  listPlay,
  updatePlay
} from "@/api/music";
import player from "@/views/Music/components/player";

const Form = {
  id: undefined,
  name: undefined,
  url: []
};
export default {
  name: "play",
  components: {
    player,
  },
  data() {
    return {
      list: [],
      meta: undefined,
      dialogVisible: false,
      submitForm: Form,
      listForm: {
        name: undefined,
        pagination: {
          currentPage: 1,
          limit: 20
        }
      },
      rules: {
        name: [{ required: true, message: "请输入视频名称", trigger: "blur" }],
        url: [
          {
            type: "array",
            required: true,
            message: "请上传视频文件",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    resetPagination() {
      this.listForm.pagination = { currentPage: 1, limit: 20 }
      this.init()
    },
    handlePlayer({ row }) {
      this.$refs.player.show(row, "video");
    },
    changed(page) {
      this.listForm = Object.assign(this.listForm,{...page})
      this.init();
    },
    remove() {
      this.submitForm.url = [];
    },
    success(customList) {
      this.submitForm.url = customList;
    },
    onSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          if (this.submitForm.id) {
            await updatePlay(this.submitForm);
          } else {
            await createPlay(this.submitForm);
            this.listForm.pagination.currentPage = 1;
          }
          this.$message.success("操作成功");
          await this.init();
          this.dialogVisible = false;
        }
      });
    },
    handleOpera({ row }) {
      if (row) {
        this.submitForm = { ...row };
      } else {
        this.submitForm = { ...Form };
      }
      this.dialogVisible = true;
    },
    onDelete({ row }) {
      this.$confirm("确定删除此演奏视频?", "提示", { type: "warning" }).then(
        async () => {
          await deletePlay(row.id);
          await this.init();
          this.$message.success("删除成功");
        }
      );
    },
    async init() {
      let { collection, meta } = await listPlay(this.listForm);
      this.list = collection;
      this.meta = meta;
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
</style>